const getters = {
  tripFilter: state => state.tripFilter,
  tripList: state => state.trips,
  hasEmpty: state => state.hasEmpty,
  showLoading: state => state.showLoading,
  tripDetails: state => state.tripDetails,
  trackFormLoading: state => state.trackFormLoading,
  trackMeta: state => state.trackMeta,
};

export default getters;
